var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_59)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0H0.5V20H20.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_59)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0H0.5V20H20.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.625 4.375C3.45924 4.375 3.30027 4.30915 3.18306 4.19194C3.06585 4.07473 3 3.91576 3 3.75C3 3.58424 3.06585 3.42527 3.18306 3.30806C3.30027 3.19085 3.45924 3.125 3.625 3.125H17.375C17.5408 3.125 17.6997 3.19085 17.8169 3.30806C17.9342 3.42527 18 3.58424 18 3.75C18 3.91576 17.9342 4.07473 17.8169 4.19194C17.6997 4.30915 17.5408 4.375 17.375 4.375H3.625ZM6.125 1.875C5.95924 1.875 5.80027 1.80915 5.68306 1.69194C5.56585 1.57473 5.5 1.41576 5.5 1.25C5.5 1.08424 5.56585 0.925268 5.68306 0.808058C5.80027 0.690848 5.95924 0.625 6.125 0.625H14.875C15.0408 0.625 15.1997 0.690848 15.3169 0.808058C15.4342 0.925268 15.5 1.08424 15.5 1.25C15.5 1.41576 15.4342 1.57473 15.3169 1.69194C15.1997 1.80915 15.0408 1.875 14.875 1.875H6.125ZM0.5 16.25C0.5 16.7473 0.697544 17.2242 1.04918 17.5758C1.40081 17.9275 1.87772 18.125 2.375 18.125H18.625C19.1223 18.125 19.5992 17.9275 19.9508 17.5758C20.3025 17.2242 20.5 16.7473 20.5 16.25V7.5C20.5 7.00272 20.3025 6.52581 19.9508 6.17417C19.5992 5.82254 19.1223 5.625 18.625 5.625H2.375C1.87772 5.625 1.40081 5.82254 1.04918 6.17417C0.697544 6.52581 0.5 7.00272 0.5 7.5V16.25ZM2.375 16.875C2.20924 16.875 2.05027 16.8092 1.93306 16.6919C1.81585 16.5747 1.75 16.4158 1.75 16.25V7.5C1.75 7.33424 1.81585 7.17527 1.93306 7.05806C2.05027 6.94085 2.20924 6.875 2.375 6.875H18.625C18.7908 6.875 18.9497 6.94085 19.0669 7.05806C19.1842 7.17527 19.25 7.33424 19.25 7.5V16.25C19.25 16.4158 19.1842 16.5747 19.0669 16.6919C18.9497 16.8092 18.7908 16.875 18.625 16.875H2.375Z",
    fill: "#CE9944"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiCollection);
export default __webpack_public_path__ + "static/media/bi_collection.0a0e7cb8fb125e06c1374bf763cc2e28.svg";
export { ForwardRef as ReactComponent };